import { Route } from 'react-router-dom';

import { TenantAdminDetailPage } from './pages/tenant-admin-detail-page.js';
import { TenantAdminFormPage } from './pages/tenant-admin-form-page.js';
import { TenantAdminListPage } from './pages/tenant-admin-list-page.js';

/**
 * The module's routes, owned by the module.
 *
 * Returned as a fragment of `<Route>` elements so the app's router composes
 * modules rather than enumerating every screen in one file.
 */
export function tenantAdminRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/tenant-admins" element={<TenantAdminListPage />} />
      <Route path="/tenant-admins/new" element={<TenantAdminFormPage />} />
      <Route path="/tenant-admins/:userId/edit" element={<TenantAdminFormPage />} />
      <Route path="/tenant-admins/:userId" element={<TenantAdminDetailPage />} />
    </>
  );
}
